import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import { encrypt } from 'utils/rsa'
import keyMirror from 'pkeymirror'
import { getAppSalt } from 'store/siteConfig'
import { getUUID } from 'utils'

// ------------------------------------
// Constants
// ------------------------------------
export const PAYMENTS_NATIVE_QUICK_PAY = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
}, 'PAYMENTS_NATIVE_QUICK_PAY')

// ------------------------------------
// Actions
// ------------------------------------
export function init(data) {
  return (dispatch, getState) => {
    const saltKey = getUUID()
    dispatch(getAppSalt(saltKey)).then((res) => {
      const { salt } = res.payload
      const { agreements, cvv, cardNo, ...restData } = data
      restData.cvv = encrypt(cvv, salt)
      restData.cardNo = encrypt(cardNo.replace(/ /g, ''), salt)
      dispatch(
        callAPI({
          dispatch: dispatch,
          method: 'POST',
          header: {
            'Salt-Key': saltKey,
          },
          body: restData,
          endpoint: 'cgs/personal/card/payment/bind',
          requestAction: PAYMENTS_NATIVE_QUICK_PAY.INIT_REQUEST,
          successAction: PAYMENTS_NATIVE_QUICK_PAY.INIT_SUCCESS,
          success: function(result) {
            window.location.href = `?cardToken=cardId:${result.cardId}`
          },
        })
      )
    })
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [PAYMENTS_NATIVE_QUICK_PAY.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [PAYMENTS_NATIVE_QUICK_PAY.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'paymentsNativeQuickPay',
    reducerMap: {
      paymentsNativeQuickPayState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
